export const charOptions = [
	{
		label: 'タグ',
		options: [
			{ value: '躁のイマジア', label: '躁のイマジア' },
			{ value: 'シュガビタエブリデイズ', label: 'シュガビタエブリデイズ' },
			{ value: '代理', label: '代理' },
			{ value: '主人公', label: '主人公' },
			{ value: '元人間', label: '元人間' },
			
			{ value: '武闘派', label: '武闘派' },
			
			{ value: '男の子', label: '男の子' },
			{ value: '女の子', label: '女の子' },
			
			{ value: '2頭身', label: '2頭身' },
			{ value: '2.5頭身', label: '2.5頭身' },
		]
	}
];

export const charSortOptions = [
	{ value: "titleAsc", label: "名前順 (昇順)" },
	{ value: "titleDesc", label: "名前順 (降順)" },
	{ value: "debutAsc", label: "デビュー順 (古い順)" },
	{ value: "debutDesc", label: "デビュー順 (新しい順)" },
];

export const getCharTagLabel = (value: string) => {
	const allSubOptions = charOptions.flatMap(group => group.options);
	const target = allSubOptions.find(opt => opt.value === value);
	return target ? target.label : value;
};
